// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.LoginOptions__divider-ffd697 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  color: var(--base-80);
  font: var(--font-body-2);
  letter-spacing: var(--font-spacing-body-2);
  padding: 24px 0;
}

.LoginOptions__divider-ffd697::after,
.LoginOptions__divider-ffd697::before {
  content: "";
  flex: 1;
  height: 1px;
  width: 100%;
  background-color: var(--base-20);
}

.LoginOptions__buttons-df2920 {
  display: flex;
  flex-direction: column;
  gap: 16px;
}`, "",{"version":3,"sources":["webpack://./src/pages/authorization/Login/LoginOptions/LoginOptions.styles.m.css"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,qBAAA;EACA,wBAAA;EACA,0CAAA;EACA,eAAA;AACF;;AAEA;;EAEE,WAAA;EACA,OAAA;EACA,WAAA;EACA,WAAA;EACA,gCAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AACF","sourcesContent":[".divider {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 24px;\n  color: var(--base-80);\n  font: var(--font-body-2);\n  letter-spacing: var(--font-spacing-body-2);\n  padding: 24px 0;\n}\n\n.divider::after,\n.divider::before {\n  content: \"\";\n  flex: 1;\n  height: 1px;\n  width: 100%;\n  background-color: var(--base-20);\n}\n\n.buttons {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"divider": `LoginOptions__divider-ffd697`,
	"buttons": `LoginOptions__buttons-df2920`
};
module.exports = ___CSS_LOADER_EXPORT___;
